module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIyMSIgdmlld0JveD0iMCAwIDE2IDIxIj4KICA8cGF0aCBpZD0iaW1nX3dheV9yaWdodCIgZD0iTTEwLjUsMCwyMSwxNkgwWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTYpIHJvdGF0ZSg5MCkiIGZpbGw9IiNmZmYiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_way_right.svg
// module id = Ja1d
// module chunks = 0